<script setup lang="ts">
import { computed } from "vue";
import { trackAppSetting } from "@/analytics/app-analytics";
import { useTranslation } from "i18next-vue";
import SettingsOptionRow from "./SettingsOptionRow.vue";
import HandwritingFeatureState from "@/stores/HandwritingFeatureState";

const { t } = useTranslation();

const status = computed(() => HandwritingFeatureState.status);

function proposeAgain() {
  trackAppSetting("handwriting_feature", "reset");
  HandwritingFeatureState.reset();
}
</script>

<template>
  <SettingsOptionRow
    :label="t('dashboard:settings.handwriting.title')"
    icon="bi-vector-pen"
  >
    <span v-if="status === 'installed'" class="text-success">
      {{ t("dashboard:settings.handwriting.statusInstalled") }}
    </span>
    <span v-else-if="status === 'new'" class="text-muted small">
      {{ t("dashboard:settings.handwriting.statusNew") }}
    </span>
    <el-button v-else size="small" @click="proposeAgain">
      {{ t("dashboard:settings.handwriting.proposeAgain") }}
    </el-button>
  </SettingsOptionRow>
</template>
